import { hasFeature } from '@/mixins/hasFeature.js';

export const isInoperableCategory = (caseCategory, catsaExtrasConfig) => {
    const key = catsaExtrasConfig?.inoperable_category_key;
    return typeof key === 'string' && caseCategory === key;
};

export const isCatsaExtrasApplicable = (workOrderType, config) => {
    if (!hasFeature('work_order_catsa_extras')) return false;
    return (config?.work_order_types ?? []).includes(workOrderType);
};

export const isMsdNotificationApplicable = (assetType, caseCategory, workOrderType, catsaExtrasConfig, msdConfig) => {
    if (!isCatsaExtrasApplicable(workOrderType, catsaExtrasConfig)) return false;
    if (!isInoperableCategory(caseCategory, catsaExtrasConfig)) return false;
    return (msdConfig?.asset_types ?? []).includes(assetType);
};

export const isMsdNotificationComplete = (msd) => {
    const v = msd ?? {};
    if (typeof v.called !== 'boolean') return false;
    if (v.called === true) {
        if (!v.name || !v.called_at) return false;
    }
    return true;
};

export const isTroubleshootingApplicable = (caseCategory, workOrderType, catsaExtrasConfig) => {
    if (!isCatsaExtrasApplicable(workOrderType, catsaExtrasConfig)) return false;
    return isInoperableCategory(caseCategory, catsaExtrasConfig);
};

export const isTroubleshootingComplete = (troubleshooting) => typeof (troubleshooting ?? {}).troubleshot === 'boolean';

export const isCaseCategoryComplete = (category, subcategory) => Boolean(category) && Boolean(subcategory);

// Strip the inoperable option for users without ASSET_UPDATE_OPERABILITY. The currently-stored
// inoperable category stays in the list so the readonly label resolves on legacy WOs.
export const visibleCaseCategories = (caseCategories, currentCategory, catsaExtrasConfig, canUpdateAssetOperability) => {
    const all = caseCategories ?? [];
    if (canUpdateAssetOperability) return all;
    const inoperableKey = catsaExtrasConfig?.inoperable_category_key;
    return all.filter((c) => c.key !== inoperableKey || c.key === currentCategory);
};
